import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.css']
})
export class SpinnerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    document.documentElement.style.setProperty('--primary-color', environment.primaryColor);
    document.documentElement.style.setProperty('--secondary-color', environment.secondaryColor);
  }

}
